import createReactComponent from '../createReactComponent';
export default createReactComponent('id-badge-2', 'IconIdBadge2', [
  ['path', { d: 'M7 12h3v4h-3z', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6',
      key: 'svg-1',
    },
  ],
  [
    'path',
    {
      d: 'M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z',
      key: 'svg-2',
    },
  ],
  ['path', { d: 'M14 16h2', key: 'svg-3' }],
  ['path', { d: 'M14 12h4', key: 'svg-4' }],
]);
